import { render, staticRenderFns } from "./TableColumnSelectItem.vue?vue&type=template&id=0a8aeba8&"
import script from "./TableColumnSelectItem.vue?vue&type=script&lang=js&"
export * from "./TableColumnSelectItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports